export const UPPER_AND_LOWER_FORM = "7020997";

export const UPPER_AND_LOWER_FORM_FIELDS = Object.freeze({
  WAS_HYDRODISSECTION_PROCEDURE_CHECKBOX: "197873706",
  HYDRODISSECTION_INJECTION_SITES: "197873707",
  HYDRODISSECTION_SIDE: "197873710",
  WAS_PRP_PROCEDURE_CHECKBOX: "192224274",
  PRP_PROCEDURE_AMOUNT_OF_BLOOD_DRAWN: "191611509",
  // PRP_PROCEDURE_FURTHER_DETAILS: '191611510',
  SIDES_INJECTED: "191611495",
  UPPER_BODY_INJECTION_SITES: "192208618",
  LOWER_BODY_INJECTION_SITES: "192640863",
  FURTHER_INJECTION_DETAILS: "192210026",
  FIRST_INJECTATE: "192226034",
  FIRST_INJECTATE_QUANTITY: "192226035",
  SECOND_INJECTATE: "192226036",
  SECOND_INJECTATE_QUANTITY: "192226037",
  PERCENT_RELIEF_DETAILS: '191611490',
  OUTCOME: "191611472",
  POST_PROCEDURE_COMMENTS: "191611485",
} as const);

export type UpperAndLowerFormFields = keyof typeof UPPER_AND_LOWER_FORM_FIELDS;

export const UPPER_AND_LOWER_FORM_FIELDS_SET = new Set(
  (Object.keys(UPPER_AND_LOWER_FORM_FIELDS) as UpperAndLowerFormFields[]).map(
    (key: UpperAndLowerFormFields) => UPPER_AND_LOWER_FORM_FIELDS[key]
  )
);

export const UPPER_AND_LOWER_REQUIRED_FIELDS = [
  UPPER_AND_LOWER_FORM_FIELDS.SIDES_INJECTED,
  UPPER_AND_LOWER_FORM_FIELDS.FIRST_INJECTATE,
  UPPER_AND_LOWER_FORM_FIELDS.FIRST_INJECTATE_QUANTITY,
];
